import { create } from "zustand";
import { AgglomerationI } from "@/types/base";

interface AgglomerationState {
  selectedAgglomeration: AgglomerationI | null;
  initialAgglomerationIsSet: boolean;
  setSelectedAgglomeration: (hexGroup: AgglomerationI) => void;
}

export const useAgglomeration = create<AgglomerationState>()((set) => ({
  selectedAgglomeration: null,
  initialAgglomerationIsSet: false,
  setSelectedAgglomeration: (hexGroup) =>
    set({ selectedAgglomeration: hexGroup, initialAgglomerationIsSet: true }),
}));
